
export class ExpressanfragePostData {
    public ansprechpartner:string;
    public wunschtermin:string;
    public description:string;
    public productAndNumber:string;
    public email:string;
    public tel:string;
    public anfrage:string;
    public lieferOrt:string;
}

export type FileUploadResponse  = {
    filename:string;
    success:boolean;
    derived_UserDataPath:string;
    id:number;
    error:string;
    type:string;
}


export type CountryListStateEntry = {
    kuerzel:string;
    state:string;
}


export type CountrylistEntry = {
    iso3166:string;
    landIntName:string;
    isEu;
}

export type CountryListResponse ={
    suggestedCountry:string;
    countryList: CountrylistEntry[];
    stateList:CountryListStateEntry[];
}

export type WKMenu_WKPosition = {
    imageURL;
    anz;
    price;
    productShort;
    waehrung;
    mengenbezeichner;
    amountString;
    groesse;
}
